import type { WidgetI18nKey } from "./i18nKeys";

const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const WEEK_MS = 7 * DAY_MS;
const MONTH_MS = 30 * DAY_MS;

export type RelativeTimeBucket = {
  key: WidgetI18nKey;
  count: number;
};

export function getRelativeTimeBucket(
  publishedAt: number,
  now: number = Date.now(),
): RelativeTimeBucket {
  const elapsed = Math.max(0, now - publishedAt);
  if (elapsed < MINUTE_MS) return { key: "relativeJustNow", count: 0 };
  if (elapsed < HOUR_MS)
    return { key: "relativeMinutesAgo", count: Math.floor(elapsed / MINUTE_MS) };
  if (elapsed < DAY_MS) return { key: "relativeHoursAgo", count: Math.floor(elapsed / HOUR_MS) };
  if (elapsed < WEEK_MS) return { key: "relativeDaysAgo", count: Math.floor(elapsed / DAY_MS) };
  if (elapsed < MONTH_MS) return { key: "relativeWeeksAgo", count: Math.floor(elapsed / WEEK_MS) };
  return { key: "relativeMonthsAgo", count: Math.floor(elapsed / MONTH_MS) };
}
